import React, { Component } from "react";
import PageHeader from "../pageHeader";
import PageIntro from "../pageIntro";
import LikeDislikeBanner from "../likeDislikeBanner";
import TabH2P from "./tabH2P";
import SectionH2P from "./sectionH2P";
import ServicesSection from "../servicesSection";
import DIYSection from "../DIYSection";
import { isMobile, imageUrl } from "helpers/ApplicationHelper";
import { connect } from "react-redux";
const EVENTS_LABEL = "from How To Price page";

class HowToPrice extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedTab: "Retail",
        };

        this.isMobile = isMobile();
    }

    //data methods are separated for editing convinience

    tabsData() {
        return [
            {
                bigIcon: "experts/howToPrice/retailBar.svg",
                smallIcon: "experts/howToPrice/retailRing.svg",
                tabTitle: "Retail",
                tabSubtitle: "New diamond jewelry pricing breakdown",
            },
            {
                bigIcon: "experts/howToPrice/resaleBar.svg",
                smallIcon: "experts/howToPrice/resaleRing.svg",
                tabTitle: "Resale",
                tabSubtitle: "Pre-owned diamond jewelry pricing breakdown",
            },
        ];
    }

    retailSectionsData() {
        return [
            {
                number: 1,
                sectionPic: "experts/howToPrice/retail1.svg",
                sectionPicMobile: "experts/howToPrice/mobileRetail1.svg",
                sectionTitle: "4c’s, mining, and cutting",
                sectionText:
                    "A diamond’s price is determined by its 4 c’s (cut, carat, clarity, and color) coupled with the aggregated value created at each step of its production process (mining, cutting & polishing).",
            },
            {
                number: 2,
                sectionPic: "experts/howToPrice/retail2.svg",
                sectionPicMobile: "experts/howToPrice/mobileRetail2.svg",
                sectionTitle: "Jewelry Manufacturing",
                sectionText:
                    "Once the diamond is ready, it is placed into a setting by jewelry manufacturers. While the metal and melee diamonds that comprise the setting hold some value on their own, the factors that raise the price most significantly are the design and craftsmanship costs.",
                reverse: true,
            },
            {
                number: 3,
                sectionPic: "experts/howToPrice/retail3.svg",
                sectionPicMobile: "experts/howToPrice/mobileRetail3.svg",
                sectionTitle: "Retail Business Expenses",
                sectionText:
                    "Once the piece is ready, and sold to the buyer (who sells the piece to the eventual owner), retail operating costs, marketing costs, and profit margins are added and the retail price is set.",
            },
        ];
    }

    resaleSectionsData() {
        return [
            {
                number: 1,
                sectionPic: "experts/howToPrice/resale1.svg",
                sectionPicMobile: "experts/howToPrice/mobileResale1.svg",
                sectionTitle: "Additional Labor",
                sectionText:
                    "A pre-owned diamond often needs to be reset, recut, or repolished in order to be resold. If that is the case, the price a buyer will offer for it may be lowered significantly.",
            },
            {
                number: 2,
                sectionPic: "experts/howToPrice/resale2.svg",
                sectionPicMobile: "experts/howToPrice/mobileResale2.svg",
                sectionTitle: "Setting & Melee",
                sectionText:
                    "At resale, a diamond jewelry piece is normally dismantled, with the largest diamond reset in a new piece. That leaves the buyer with the setting and melee diamonds - neither worth very much. Melee diamonds are small and often break. The setting is reduced to its metal weight value.",
                reverse: true,
            },
            {
                number: 3,
                sectionPic: "experts/howToPrice/resale3.svg",
                sectionPicMobile: "experts/howToPrice/mobileResale3.svg",
                sectionTitle: "Retail Business Expenses",
                sectionText:
                    "A buyer needs to purchase the diamond at a discount from the retail and wholesale prices to compensate for operating costs, risks, and other expenses associated with their business.",
            },
        ];
    }

    renderDevider(reverse) {
        return (
            <div className="dots-divider-container d-flex flex-justify-center">
                <img
                    style={{ transform: reverse ? "scaleX(-1)" : "none" }}
                    alt="dots-divider"
                    src={imageUrl("experts/howToPrice/desktopDottedLine.svg")}
                />
            </div>
        );
    }

    render() {
        const { selectedTab } = this.state;
        const retailSectionsData = this.retailSectionsData();
        const resaleSectionsData = this.resaleSectionsData();
        const selectedTabData =
            selectedTab === "Resale" ? resaleSectionsData : retailSectionsData;
        return (
            <div className="how-to-price">
                <div className="h2p margin-0-auto d-flex flex-col">
                    <div className="h2p-header">
                        <PageHeader
                            label={{ title: "Resource", color: "#C7427C" }}
                            title="How Pre-owned Diamond Jewelry is Priced"
                            diamondText="Pricing guide"
                        />
                        <PageIntro
                            pic={{
                                alt: "diamond-ask icon",
                                url: "experts/howToPrice/resaleDiamondIcon.svg",
                            }}
                            text="The pre-owned diamond market plays by entirely different rules compared to the retail diamond market. This results in very high retail prices, and then shockingly low resale prices."
                        />
                    </div>
                    <div className="h2p-content margin-0-auto">
                        <div className="tabs-container d-flex">
                            <div className="tabs-slider d-flex w-100">
                                {this.tabsData().map((tab, i) => {
                                    return (
                                        <TabH2P
                                            key={i}
                                            data={tab}
                                            active={
                                                selectedTab === tab.tabTitle
                                            }
                                            click={() => {
                                                this.setState({
                                                    selectedTab: tab.tabTitle,
                                                });
                                            }}
                                        />
                                    );
                                })}
                            </div>
                        </div>
                        <div className="tab-container d-flex flex-col">
                            {selectedTabData.map((section, i) => {
                                return (
                                    <React.Fragment key={i}>
                                        <SectionH2P data={section} />
                                        {i < selectedTabData.length - 1
                                            ? this.renderDevider(
                                                  section.reverse
                                              )
                                            : null}
                                    </React.Fragment>
                                );
                            })}
                        </div>
                    </div>
                    <LikeDislikeBanner
                        question="Was this content helpful?"
                        closingText="Thank you for your feedback!"
                        eventsLabel="from How To Price page"
                    />
                </div>
                <DIYSection
                    eventsLabel={EVENTS_LABEL}
                    data={["WHERE_TO_SELL"]}
                    recomended={true}
                />
                <div className="cards-container">
                    <ServicesSection
                        pageName="How To Price"
                        lastItem={this.props.LastItem}
                    />
                </div>
            </div>
        );
    }
}

const mapStateToProps = ({ LastItem }) => {
    return {
        LastItem,
    };
};

export default connect(mapStateToProps)(HowToPrice);
